module.exports = {"type":"Typ","ic":"IČ/RČ","name":"Názov/Méno","address":"Adresa","rowDt":"Dátum vloženia","insertDate":"Dátum vloženia"}